export const APP_ROUTES = {
    home: '/',
    signIn: '/signin',
    projects: '/dashboard',
    sharedProjects: '/dashboard/shared',
    recentlyDeleted: '/dashboard/recently-deleted',
    account: '/dashboard/account',
    adminAi: '/dashboard/admin/ai',
    legacyProfile: '/dashboard/profile',
    legacySettings: '/dashboard/settings',
} as const;

export type WorkspaceNavigationKey = 'projects' | 'sharedProjects' | 'recentlyDeleted' | 'account';

export interface WorkspaceNavigationItem {
    readonly key: WorkspaceNavigationKey;
    readonly label: string;
    readonly path: string;
    readonly end: boolean;
}

/**
 * Canonical workspace destinations shared by every application shell.
 *
 * Icons deliberately stay in the rendering components so this registry remains
 * dependency-free and can also be consumed by routing and non-React code.
 */
export const WORKSPACE_NAVIGATION = {
    projects: {
        key: 'projects',
        label: 'Projects',
        path: APP_ROUTES.projects,
        end: true,
    },
    sharedProjects: {
        key: 'sharedProjects',
        label: 'Shared with me',
        path: APP_ROUTES.sharedProjects,
        end: true,
    },
    recentlyDeleted: {
        key: 'recentlyDeleted',
        label: 'Recently Deleted',
        path: APP_ROUTES.recentlyDeleted,
        end: true,
    },
    account: {
        key: 'account',
        label: 'Account',
        path: APP_ROUTES.account,
        end: false,
    },
} as const satisfies Readonly<Record<WorkspaceNavigationKey, WorkspaceNavigationItem>>;

export const WORKSPACE_NAV_ITEMS: readonly WorkspaceNavigationItem[] = [
    WORKSPACE_NAVIGATION.projects,
    WORKSPACE_NAVIGATION.sharedProjects,
    WORKSPACE_NAVIGATION.recentlyDeleted,
    WORKSPACE_NAVIGATION.account,
];

/** Compact account menus link to destinations, not dashboard collection filters. */
export const ACCOUNT_MENU_NAV_ITEMS = [
    WORKSPACE_NAVIGATION.projects,
    WORKSPACE_NAVIGATION.account,
] as const satisfies readonly WorkspaceNavigationItem[];

export type AccountMenuNavigationKey = typeof ACCOUNT_MENU_NAV_ITEMS[number]['key'];

/** Existing bookmarks continue to work, but all account editing has one URL. */
export const LEGACY_ACCOUNT_ROUTES: readonly string[] = [
    APP_ROUTES.legacyProfile,
    APP_ROUTES.legacySettings,
];
